// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","565":"component---src-templates-page-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"a39bcd392881943b1ec9","532":"b386ddc9da282a52c09a","565":"054f0913441957d31760","774":"8b7e896f814af24e06ec","883":"738537693fabc8f4f84f"}[chunkId] + ".js";
};